import DetailPanel from 'Components/Generic/DetailPanel';
import PropTypes from 'prop-types';
import AccountsTable from '../ChargeAccounts/AccountsTable';

const AccountsListPanel = ({
  editable = false,
  disabled = false,
  ...props
}) => {
  return (
    <DetailPanel
      title='Accounts'
      editable={editable}
      disabled={disabled}
      collapsible>
      <AccountsTable editable={editable} {...props} />
    </DetailPanel>
  );
};

AccountsListPanel.propTypes = {
  editable: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default AccountsListPanel;
